import * as React from 'react';
import * as moment from "moment";
import {Option} from "ts-option";
import DateUtils from "../../../utils/DateUtils";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface Props {
	/**
	 * Last updated date.
	 */
	date: Option<moment.Moment>;
	/**
	 * User's consent.
	 */
	consent: Option<boolean>;
	/**
	 * Form group label
	 */
	label: string;
}

export default class ContactConsentFormGroup extends React.Component<Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label}>
				<div className="c-contact-consent-form-group">
					<div className="c-contact-consent-form-group_consent">
						{this.props.consent.getOrElse(false) ? "Accepted" : "Not accepted"} &nbsp;
					</div>
					<div className={"c-contact-consent-form-group_update"}>
						{this.props.date.map(d => `Last updated: ${d.format(DateUtils.DATE_TIME_FORMAT)}`).getOrElse(
							"Never updated")}
					</div>
				</div>
			</FormGroup>
		);
	}
}
